import React from 'react';
import { List, Popup } from 'semantic-ui-react';
import { NombrePersonal as NombrePersonalDTO } from 'src/api/protocolo';
import { BloqueHorario } from 'src/api/protocolo/horarios';
import { Dia, NombrePersonal } from 'src/componentes';
import { LinkCurso } from 'src/componentes/LinkCurso';

type PropsInformacionDeCurso = Readonly<{
    id: number;
    nombre: string;
    sala: string;
    bloqueHorario: BloqueHorario;
    dia: number;
    profesor?: {
        nombre: NombrePersonalDTO;
    };
}>;

export const InformacionDeCurso = (props: PropsInformacionDeCurso) => {
    const { nombre, profesor, bloqueHorario: bloqueHorarioCompleto, dia } = props;

    const bloqueHorario = `${bloqueHorarioCompleto.horaInicio}-${bloqueHorarioCompleto.horaTermino}`;

    return (
        <Popup trigger={<LinkCurso codigo={nombre} />} closeOnEscape hideOnScroll>
            <Popup.Header>{nombre}</Popup.Header>
            <Popup.Content>
                <List relaxed>
                    <List.Item>
                        <List.Icon name='calendar outline' />
                        <List.Content>
                            <Dia dia={dia} />
                            {` ${bloqueHorario}`}
                        </List.Content>
                    </List.Item>
                    {profesor ? (
                        <List.Item>
                            <List.Icon name='user' />
                            <List.Content>
                                {<NombrePersonal nombre={profesor.nombre} patron='%N %P %m' />}
                            </List.Content>
                        </List.Item>
                    ) : (
                        <List.Item>
                            <List.Icon name='user' />
                            <List.Content>No asignado</List.Content>
                        </List.Item>
                    )}
                </List>
            </Popup.Content>
        </Popup>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/componentes/InformacionDeCurso.tsx